'use strict';

import modalDirective from 'brg/rest/buttons/modal';

import template from './template.html';

export default modalDirective({
	template: template,
	controller: controller,
});


function controller($scope, $http) {
	'ngInject';

	$scope.submitting = false;
	$scope.errors = null;

	$scope.submitData = function() {
		if ($scope.submitting) return;
		$scope.submitting = true;
		const url = '/api/teams/beats/create_phone/';
		const data = {
			user_id: $scope.$context.user.uuid,
			phone_number: $scope.phoneNumber,
			phone_type: $scope.phoneType,
			pin: $scope.pin || null,
			call_after_count: $scope.backupPhone ? $scope.callAfterCount : 0,
		};

		console.log(data);

		$http({
			method: 'POST',
			url: url,
			data: data,
		}).then((response) => {
			$scope.$close(response.data);
		}, (error) => {
			console.error(error);
			$scope.errors = error.data;
		}).finally(() => {
			$scope.submitting = false;
		});
	}
}
